module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "ball_top_air.2590513b.svg";